<div class="flex h-full w-full flex-col items-center justify-between p-5">
  <div class="flex w-full flex-col justify-start">
    <div class="w-full md:w-1/2 lg:w-1/3">
      <p class="font-semibold">
        Conjunto de puntajes alcanzados por grupos de Evaluadores
      </p>
      <mat-divider class="w-full border border-[#DEE2E6]" />
    </div>
  </div>
  <div class="flex w-full flex-col items-center justify-between md:flex-row">
    <div #legendContainer></div>
    <canvas #radarChart class="h-[300px] flex-1 md:h-[550px]"></canvas>
  </div>
</div>
